import api from '@/api/approval'
import errorhandler from '@/utils/errorhandler'

export default {
  state: {
    users: []
  },
  namespaced: true,
  actions: {
    async approve({ dispatch }, data) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const roomEvents = data.map(d => { return { roomId: d.roomId, eventId: d.eventId } })
        await api.approve(roomEvents)

        dispatch('Global/showMessage', 'approveSuccess', { root: true })

      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async reject({ dispatch }, data) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const roomEvents = data.map(d => { return { roomId: d.roomId, eventId: d.eventId } })
        await api.reject(roomEvents)

        dispatch('Global/showMessage', 'rejectSuccess', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async loadPendingApprovalBookings({ dispatch }, user) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const response = await api.getEvents(user ?? '')
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
  }
}
